(function () {
(function($) {
    const behavior = "polyu_theme.top-search-overlay";
    Drupal.behaviors[behavior] = {
        attach: (context, settings)=>{}
    };
    $(function() {
        polyu_handle_top_search_overlay();
    });
    function polyu_handle_top_search_overlay() {
        $(".trigger-search").on("click", function(e) {
            e.preventDefault();
            $("body").addClass("fixed-region-active");
            $(".region--top").addClass("is-active");
            $(".polyu_top_search_overlay").slideDown();
        });
        $(".sliding_pane_close").on("click", function(e) {
            e.preventDefault();
            $(".polyu_top_search_overlay").slideUp(function() {
                $(".region--top").removeClass("is-active");
                $("body").removeClass("fixed-region-active");
            });
        });
    }
})(jQuery);

})();
//# sourceMappingURL=block--polyu-search-block--top.js.map
